// Constants
export const afiliado_beneficiarios = () => {
    return {
        afiliado_beneficiarios: {
            id: {
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                type: "number",
                label: "id",
                placeholder: "",
                description: "",
                validate: "",
                datatype: {
                    type: "input",
                    disabled: true,
                    predeterminate: "",
                }
            },
            id_datos_afiliado: {
                type: "text",
                label: "datos afiliado",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                description: "",
                validate: "",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "datos_razon",
                    label: 'name'
                }
            },
            id_list_users: {
                type: "text",
                label: "Usuario",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: null,
                    list: "list_users",
                    label: 'name',
                }
            },
            id_list_documento: {
                type: "text",
                label: "Tipo",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: 1,
                    list: "list_documento",
                    label: 'name',
                }
            },
            documento: {
                type: "text",
                label: "Documento",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            name: {
                type: "text",
                label: "Nombres",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: "",
                }
            },
            servicios: {
                type: "text",
                label: "Incluir en servicios",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                description: "",
                validate: "required",
                datatype: {
                    type: "select",
                    disabled: false,
                    predeterminate: [],
                    list: "list_servicios",
                    label: 'name',
                    multiple: true
                },
            },
            nacimiento: {
                type: "date",
                label: "F. Nacimiento",
                placeholder: "",
                namepath: ['afiliacion_nueva', 'afiliado_crear', 'servicios_afiliacion', 'afiliacion_inclusiones', 'afiliado_ficha'],
                description: "",
                validate: "",
                datatype: {
                    type: "date",
                    disabled: false,
                    predeterminate: null,
                }
            },
            nota_delete: {
                type: "text",
                label: "Nota",
                placeholder: "",
                namepath: [''],
                description: "",
                validate: "required",
                datatype: {
                    type: "input",
                    disabled: false,
                    predeterminate: null
                }
            },
        },
    }
}